import client from "@irati/utils/services/apollo";
import dealPackagesQuery from "./queries/dealPackage";
import currentDealPackageQuery, { getDealPackageKey } from "./queries/getCurrentDealPackage";
import dealTagsForCurrentPackage from "./queries/dealTagsForCurrentPackage";
var DealPackageService = /** @class */ (function () {
    function DealPackageService() {
        this.dealTagsForCurrentPackage = function () {
            return client.query({ query: dealTagsForCurrentPackage }).then(function (_a) {
                var data = _a.data;
                return data.dealTagsForCurrentPackage.results;
            });
        };
    }
    DealPackageService.prototype.list = function () {
        return client.query({ query: dealPackagesQuery }).then(function (_a) {
            var data = _a.data;
            return data.getDealPackages.results;
        });
    };
    DealPackageService.prototype.getCurrentPackage = function () {
        return client.query({ query: currentDealPackageQuery }).then(function (res) { return res.data[getDealPackageKey]; });
    };
    return DealPackageService;
}());
export default new DealPackageService();
